import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="section footer">
        <div className="footer-container">
          <div className="footer-content">
            <div
              data-w-id="7ccbf7a2-080d-66f9-81b6-2448b055e0d1"
              className="footer-top-content"
            >
              <div className="footer-information-wrapper">
                <div className="footer-information-single">
                  <div className="footer-logo-description">
                    <a
                      href="/"
                      className="footer-logo-link-block w-inline-block"
                    >
                      <img
                        src="/images/noa-logo.png"
                        loading="lazy"
                        alt=""
                        className="footer-logo-image"
                      />
                    </a>
                    <p
                      className="footer-description-text"
                      style={{ paddingLeft: "7px" }}
                    >
                      {t("becomeTheBestVersionYourselfUtilizingTechnology")}
                    </p>
                  </div>
                </div>
                <div className="footer-information-details">
                  <div className="footer-information-details-single">
                    <img
                      src="/images/footer-20information-20details-20icon1.svg"
                      loading="lazy"
                      alt=""
                      className="footer-information-details-icon"
                    />
                    <div className="footer-information-details-text">
                      (213) 427 3457 4562
                    </div>
                  </div>
                  <div className="footer-information-details-single">
                    <img
                      src="/images/footer-20information-20details-20icon2.svg"
                      loading="lazy"
                      alt=""
                      className="footer-information-details-icon"
                    />
                    {/* <div className="footer-information-details-text">support@noa.com</div> */}
                    <a
                       href="mailto:support@noaitaly.io"
                       className="footer-information-details-text"
                       style={{ textDecoration: "none" }}
                     >
                       support@noaitaly.io
                     </a>
                  </div>
                  <div className="footer-information-details-single">
                    <img
                      src="/images/footer-20information-20details-20icon3.svg"
                      loading="lazy"
                      alt=""
                      className="footer-information-details-icon"
                    />
                    <div className="footer-information-details-text">
                      Milano (MI) Corso Italia 3 (20122)
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer-menu-wrapper">
                {/* <div className="footer-form-wrapper">
                <div className="footer-form-block w-form">
                  <form id="email-form" name="email-form" data-name="Email Form" method="get" className="footer-form"
                    data-wf-page-id="68603f7a056ff6f78f58cb16"
                    data-wf-element-id="7ccbf7a2-080d-66f9-81b6-2448b055e13b">
                    <div className="footer-form-text-wrapper"><label htmlFor="name" className="footer-form-text-block">Subscribe to
                        Newsletter</label></div>
                    <div className="footer-form-input-field-button"><input className="footer-form-input-field w-input"
                        maxLength="256" name="email-2" data-name="Email 2" placeholder="Enter Your Email..."
                        type="email" id="email-2" required="" /><input type="submit" data-wait=""
                        className="footer-form-submit-button w-button" value="" /></div>
                  </form>
                  <div className="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div className="w-form-fail">
                    <div>Oops! Something went wrong while submitting the form.</div>
                  </div>
                </div>
              </div> */}
                <div className="footer-menu-content">
                  <div className="footer-menu-single">
                    <div className="footer-menu-title-wrapper">
                      <h5 className="footer-menu-title">{t("mainPages")}</h5>
                    </div>
                    <div className="footer-menu-list-wrapper">
                      <ul role="list" className="footer-menu-list">
                        <li className="footer-menu-list-item">
                          <a
                            href="/"
                            aria-current="page"
                            className="footer-menu-text-link w--current"
                          >
                            {t("home")}
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://portal.noaitaly.io"
                            className="footer-menu-text-link w--current"
                          >
                            {t("portal")}
                          </a>
                        </li>
                        {/* <li className="footer-menu-list-item"><a href="/about" className="footer-menu-text-link">About</a>
                      </li>
                      <li className="footer-menu-list-item"><a href="/pricing" className="footer-menu-text-link">Pricing</a>
                      </li>
                      <li className="footer-menu-list-item"><a href="/Technology" className="footer-menu-text-link">Technology</a></li>
                      <li className="footer-menu-list-item"><a href="/contact-us" className="footer-menu-text-link">Contact</a>
                      </li> */}
                      </ul>
                    </div>
                  </div>
                  <div className="footer-menu-single last">
                    <div className="footer-menu-title-wrapper">
                      <h5 className="footer-menu-title">{t("quickLinks")}</h5>
                    </div>
                    <div className="footer-menu-list-wrapper">
                      <ul role="list" className="footer-menu-list">
                        <li className="footer-menu-list-item">
                          {/* <a
                            href="https://drive.google.com/file/d/1SjKctm3YEwZ8Lgx41Q4zrx0Ftd4dHocm/view?usp=drive_link"
                            className="footer-menu-text-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {t("policiesAndProcedures")}
                          </a> */}
                          <Link
                            to={"/policiesProcedures"}
                            className="footer-menu-text-link"
                          >
                            {t("policiesAndProcedures")}
                          </Link>
                        </li>
                        <li className="footer-menu-list-item">
                          <Link
                            to={"/useragreement"}
                            className="footer-menu-text-link"
                          >
                            {t("userAgreement")}
                          </Link>
                        </li>
                        <li className="footer-menu-list-item">
                          <Link
                            to={"/riskwarning"}
                            className="footer-menu-text-link"
                          >
                            {t("riskWarning")}
                          </Link>
                        </li>
                        <li className="footer-menu-list-item">
                          <Link
                            to={"/refundpolicy"}
                            className="footer-menu-text-link"
                          >
                            {t("refundPolicy")}
                          </Link>
                        </li>
                        <li className="footer-menu-list-item">
                          <Link
                            to={"/termsandcondition"}
                            className="footer-menu-text-link"
                          >
                            {t("terms&Condition")}
                          </Link>
                        </li>
                        <li className="footer-menu-list-item">
                          <Link
                            to={"/privacypolicy"}
                            className="footer-menu-text-link"
                          >
                            {t("eaconomyPrivacyPolicy")}
                          </Link>
                        </li>
                        <li className="footer-menu-list-item">
                          <Link
                            to={"/spampolicy"}
                            className="footer-menu-text-link"
                          >
                            {t("spamPolicy")}
                          </Link>
                        </li>
                        <li className="footer-menu-list-item">
                          <Link to={"/dmca"} className="footer-menu-text-link">
                            {"dmca"}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <img
                src=""
                loading="lazy"
                alt=""
                className="footer-pluse-icon top-left"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="footer-pluse-icon top-right"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="footer-pluse-icon bottom-left"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="footer-pluse-icon bottom-right"
              />
            </div>
            <div className="footer-bottom-content">
              <div className="footer-details-wrapper">
                <div className="footer-details-text">
                  © Copyright {new Date().getFullYear()} -{" "}
                  <a href="/" className="footer-details-name">
                    {t('noaItaly')}
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom-line"></div>
      </section>
    </>
  );
};

export default Footer;
